namespace GeniuzPOS.InitialData {
    export class PsPosStationColumns {
        static columnsKey = 'InitialData.PsPosStation';
    }
}
